import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../../../authentication/auth';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {

  constructor(private authAPI: AuthService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.authAPI.token) {
      return next.handle(req);
    }
    return next.handle(req.clone({ setHeaders: { Authorization: `Token ${this.authAPI.token}` } }));
  }
}
